import styled from "styled-components";

export const Contact = styled.div`
display: flex;
justify-content: center;
align-items: center;
background-color: #ECECEC;
height: 320px;
margin-top: 5%;
border-bottom: 3px solid #1476C6;
`;

export const TitleContact = styled.h1`
font-weight: 600;
color: #1476C6;
font-size: 40px;
`;

export const Button = styled.button`
background-color: #1476C6;
width: 350px;
height: 60px;
border-radius: 20px;
color: #fff;
margin-top: 3%;
cursor: pointer;
`;

export const Icon = styled.img``;

export const Footer = styled.div`
display: flex;
justify-content: space-evenly;
align-items: flex-start;
background-color: #fff;
height: 100%;
padding: 30px;
`;

export const Logo = styled.img`
margin-top: 3%;
`;

export const DescriptionFooter = styled.p`
color: #4E4E4E;
font-weight: 500;
margin-top: 3%;
`;

export const TitleFooter = styled.h1``;

export const Link = styled.a`
color: #626262;
font-weight: 500;
cursor: pointer;
text-decoration: none;
`;